// Neutralizes spreadsheet formula injection in client-generated CSV exports.
// If a cell's string value starts with =, +, -, @ (or tab/CR), prefix it with
// a single quote so Excel/Sheets/LibreOffice render it as literal text
// instead of evaluating it as a formula when a victim opens the export.
export const csvSafe = (value) => {
  const str = value === null || value === undefined ? '' : String(value);
  if (str && ['=', '+', '-', '@', '\t', '\r'].includes(str[0])) {
    return "'" + str;
  }
  return str;
};
